import React from 'react'
import LifecycleBadge from './LifecycleBadge'
import styles from '../../styles/components/assets/AssetsDataMap.module.scss'

export type DataMapRow = {
  informationSystemId: string
  informationSystemName: string
  informationSystemCode: string | null
  lifecycleStatus?: string | null
  dataCategories: Array<{ id: string; category: string; classification?: string | null }>
}

export function SectionCell({
  label,
  children,
  first,
}: {
  label: string
  children: React.ReactNode
  first?: boolean
}) {
  return (
    <div className={`${styles.rowSection} ${first ? styles.rowSectionFirst : ''}`.trim()}>
      <p className={styles.sectionHeader}>{label}</p>
      {children}
    </div>
  )
}

export function MetricDisplay({
  value,
  sub,
  unknownLabel,
}: {
  value: string | number | null | undefined
  sub?: string | null
  unknownLabel: string
}) {
  const empty =
    value === null || value === undefined || (typeof value === 'string' && value.trim() === '')
  if (empty) {
    return <p className={styles.metricUnknown}>{unknownLabel}</p>
  }
  return (
    <>
      <p className={styles.metricValue}>{value}</p>
      {sub ? <p className={styles.metricSub}>{sub}</p> : null}
    </>
  )
}

export function SystemIdentityCell({ row }: { row: DataMapRow }) {
  return (
    <div className={`${styles.systemIdentity} ${styles.rowSectionFirst}`}>
      <div className={styles.identityHeader}>
        <h4 className={styles.systemName} title={row.informationSystemName}>
          {row.informationSystemName}
        </h4>
        <LifecycleBadge status={row.lifecycleStatus} />
      </div>
      {row.informationSystemCode ? (
        <p className={styles.systemMeta}>{row.informationSystemCode}</p>
      ) : null}
    </div>
  )
}

export function CategoryPreview({ categories, emptyLabel }: { categories: DataMapRow['dataCategories']; emptyLabel: string }) {
  if (categories.length === 0) {
    return <p className={styles.metricUnknown}>{emptyLabel}</p>
  }
  const names = categories.slice(0, 4).map((c) => c.category)
  const more = categories.length > 4 ? `+${categories.length - 4}` : null
  return (
    <>
      <div className={styles.categoryPills}>
        {names.map((n) => (
          <span key={n} className={styles.categoryPill} title={n}>
            {n}
          </span>
        ))}
        {more ? <span className={styles.categoryPill}>{more}</span> : null}
      </div>
    </>
  )
}
